import { createFeature, createReducer, createSelector, on } from '@ngrx/store';

import { OrdFilterGroupEnum } from './models/ord-filter-group.enum';
import { OrdFilterGroupI } from './models/ord-filter-group.interface';
import { OrdFilterStorage } from '../../storage/storage';
import { OrdFiltersActions } from './ord-filters.actions';
import { ordFilterConstants } from './models/ord-filter-constants';

export interface State {
  activeFilterGroups: OrdFilterGroupI[];
  filterCount: number;
  filterGroups: OrdFilterGroupI[];
}

export const initialState: State = {
  activeFilterGroups: ordFilterConstants
    .map(filterGroup => filterGroup.defaultValue ? { ...filterGroup, isActive: true, value: filterGroup.defaultValue } : filterGroup)
    .filter((filterGroup) => filterGroup.isActive),
  filterCount: ordFilterConstants
    .map(filterGroup => filterGroup.defaultValue ? { ...filterGroup, isActive: true, value: filterGroup.defaultValue } : filterGroup)
    .filter((filterGroup) => filterGroup.isActive)
    .length,
  filterGroups: ordFilterConstants
    .map(filterGroup => filterGroup.defaultValue ? { ...filterGroup, isActive: true, value: filterGroup.defaultValue } : filterGroup),
};

export default createFeature({
  name: 'ordFilters',
  extraSelectors: ({ selectActiveFilterGroups }) => ({
    filterCount: createSelector(
      selectActiveFilterGroups,
      (activeFilterGroups) => activeFilterGroups?.filter(fg =>
        fg.key !== OrdFilterGroupEnum.ordDepot && fg.key !== OrdFilterGroupEnum.ordEquipment
      ).length ?? 0,
    ),
  }),
  reducer: createReducer(
    initialState,
    on(
      OrdFiltersActions.set,
      (state: State, { filterGroups }): State => {
        OrdFilterStorage.set(filterGroups);
        return ({
          ...state,
          activeFilterGroups: filterGroups.filter(
            (filterGroup) => filterGroup.isActive
          ),
          filterCount: filterGroups.filter((filterGroup) => filterGroup.isActive)
            .length,
          filterGroups,
        });
      }
    ),
    on(
      OrdFiltersActions.update,
      (state: State): State => {
        const filterGroups = OrdFilterStorage.get().length >= 1 ? OrdFilterStorage.get() : undefined;
        return ({
          ...state,
          activeFilterGroups: filterGroups ? filterGroups.filter(
            (filterGroup) => filterGroup.isActive
          ) : state.activeFilterGroups,
          filterCount: filterGroups ? filterGroups.filter((filterGroup) => filterGroup.isActive)
            .length : state.filterCount,
          filterGroups: filterGroups ? filterGroups : state.filterGroups,
        });
      }
    ),
    on(
      OrdFiltersActions.updateSingleFilter,
      (state: State, { filterGroup }): State => {
        const filterGroups: OrdFilterGroupI[] = (OrdFilterStorage.get().length >= 1 ? OrdFilterStorage.get() : []).map(fg => {
          return filterGroup.key === fg.key ? filterGroup : fg;
        });
        if (!filterGroups.find(fg => filterGroup.key === fg.key)) {
          filterGroups.push(filterGroup);
        }
        OrdFilterStorage.set(filterGroups);
        return ({
          ...state,
          activeFilterGroups: filterGroups ? filterGroups.filter(
            (filterGroup) => filterGroup.isActive
          ) : state.activeFilterGroups,
          filterCount: filterGroups ? filterGroups.filter((filterGroup) => filterGroup.isActive)
            .length : state.filterCount,
          filterGroups: filterGroups ? filterGroups : state.filterGroups,
        });
      }
    ),
    on(
      OrdFiltersActions.unSet,
      (state: State, { filter }): State => {
        const filterGroups = state.filterGroups
          .map((filterGroup) => ({
            ...filterGroup,
            isActive: filterGroup.filters.find(
              (f) => f.filterKey === filter.filterKey
            )
              ? false
              : filterGroup.isActive,
            value: filterGroup.filters.find(
              (f) => f.filterKey === filter.filterKey
            )
              ? null
              : filterGroup.value,
          }));
        OrdFilterStorage.set(filterGroups);
        return ({
          ...state,
          activeFilterGroups: filterGroups.filter((filterGroup) => filterGroup.isActive),
          filterCount: filterGroups.filter((filterGroup) => filterGroup.isActive).length,
          filterGroups,
        });
      }
    ),
    on(
      OrdFiltersActions.reset,
      (state: State, { }): State => ({
        ...initialState,
      })
    )
  )
}
);